<ng-container *ngIf="href">
    <ng-container *ngIf="target; else noTarget">
        <a
            class="app-link"
            [href]="href"
            [title]="title"
            [target]="target"
            rel="noopener noreferrer"
            [appBadge]="badgeCount || null"
            [size]="badgeCount > 9 && 'large'"
        >
            <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
        </a>
    </ng-container>
    <ng-template #noTarget>
        <a
            class="app-link"
            [href]="href"
            [title]="title"
            [appBadge]="badgeCount || null"
            [size]="badgeCount > 9 && 'large'"
        >
            <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
        </a>
    </ng-template>
</ng-container>
<a
    *ngIf="!href && appRouterLink"
    class="app-link"
    [routerLink]="appRouterLink"
    [queryParams]="queryParams"
    [queryParamsHandling]="queryParamsHandling"
    [routerLinkActive]="routerLinkActive"
    [routerLinkActiveOptions]="{ exact: true }"
    [title]="title"
    [appBadge]="badgeCount || null"
    [size]="badgeCount > 9 ? 'medium' : 'small'"
>
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
</a>
<ng-template #contentTpl><ng-content></ng-content></ng-template>
